
import { Sprout, Box, Smile, Package, Truck, Leaf, Loader2, HelpCircle } from 'lucide-react';
import { useHowItWorks } from '@/hooks/useHowItWorks';

const iconMap: { [key: string]: React.ElementType } = {
  Sprout,
  Box,
  Smile,
  Package,
  Truck,
  Leaf,
};

const HowItWorks = () => {
  const { data: steps, isLoading, error } = useHowItWorks();

  if (isLoading) {
    return (
      <section className="py-20 bg-secondary">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Loader2 className="h-10 w-10 animate-spin mx-auto text-primary" />
        </div>
      </section>
    );
  }

  if (error || !steps || steps.length === 0) {
    return null; 
  }

  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold">How Paudhify Works</h2>
          <p className="mt-4 text-lg text-muted-foreground">A seamless experience from our greenhouse to your home.</p>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-12">
          {steps.map((step) => {
            const IconComponent = iconMap[step.icon] || HelpCircle;
            return (
              <div key={step.id} className="text-center">
                <div className="flex justify-center mb-4">
                  <div className="bg-background rounded-full p-4 border">
                    <IconComponent className="h-10 w-10 text-primary" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold">{step.title}</h3>
                <p className="mt-2 text-muted-foreground">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
